<template>
    <div ref="uiMenuCardButton" class="ui-menu-card" @mouseleave="close">
        <slot  ref="uiMenuCardButton" name="button" :toggle-click="toggle" />

        <button
			:dataUi="dataUi"
            v-if="(hasContent || hasOptions) && buttonIcon"
            :style="propStyle"
            :disabled="disabled"
            :class="designBtn"
            type="button"
            class="btn-menu"
            @click="toggle">
            <em :class="icon" :style="iconSizeComputed" />
        </button>

        <div
            v-show="status"
            v-position="{'ref': $refs.uiMenuCardButton, 'options': styleOptions}"
            :class="[styleOptions ? 'options-no-modal' : 'options']"
        >
            <div class="options-content scroll-color">
                <button type="button" class="btn-close" @click="close">
                    <em class="fal fa-times" />
                </button>

                <div v-if="title" class="menu-title">{{ title }}</div>

                <div v-if="hasTopControl" class="top-control">
                    <slot name="topControl" />
                </div>
                <div v-if="hasOptions" class="menu-options" :class="design">
                    <slot name="options" />
                </div>
                <div v-else class="menu-items scroll-color-primary" :class="design">
                    <slot />
                </div>
                <div v-if="hasControl" class="control" :style="{'background': backgroundControl}">
                    <slot name="control" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'ui-menu-card',

		directives: {
			position: {
				componentUpdated: function (el, binding) {
					if (
						!binding.value.options &&
						(window.innerWidth < 1180 || el.style.display === 'none')
					) {
						el.style.top = '0'
						el.style.left = '0'
						return
					}
					el.style.position = 'fixed'

					const ref = binding.value.ref
					const distance = ref.getBoundingClientRect()
					const body = document.body
					const elementHeight = el.clientHeight
					const elementWidth = el.clientWidth

					const referenceHeight = ref.clientHeight
					const referenceWidth = ref.clientWidth
					const pixelFitY = 15
					const pixelFitX = 10

					let pixelX = 0
					let pixelY = 0

					const round = (calc) => Math.round(calc)

					// Cálculos de Y
					if (distance.top + elementHeight > body.clientHeight - 100) {
						pixelY = round(distance.top + referenceHeight - elementHeight) + pixelFitY
					} else {
						pixelY = round(distance.top - referenceHeight) + pixelFitY
					}

					// Cálculos de X
					if (distance.left - elementWidth > 0) {
						pixelX = round(distance.left + referenceWidth - elementWidth) + pixelFitX
					} else {
						pixelX = round(distance.left) - pixelFitX
					}

					el.style.top = pixelY + 'px'
					el.style.left = pixelX + 'px'
				}
			}
		},

		props: {
			title: {
				type: String,
				required: false,
				default: ''
			},
			icon: {
				type: String,
				required: false,
				default: 'far fa-ellipsis-v'
			},
			iconSize: {
				type: [Number, String],
				required: false,
				default: 16
			},
			design: {
				type: String,
				default: ''
			},
			/**
				* Estiliza o modal do menu-card
				*/
			styleOptions: {
				type: Boolean,
				default: false
			},
			backgroundControl: {
				type: String,
				default: 'transparent'
			},
			buttonIcon: {
				type: Boolean,
				default: true
			},
			propStyle: {
				type: String,
				required: false,
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false
			},
			designBtn: {
				type: String,
				required: false,
				default: ''
			},
			dataUi: {
                type: String,
                required: false,
                default: ''
            },
		},

		data() {
			return {
				status: false
			}
		},

		computed: {
			hasContent() {
				return !!this.$slots.default
			},
			hasControl() {
				return !!this.$slots.control
			},
			hasTopControl() {
				return !!this.$slots.topControl
			},
			hasButton() {
				return !!this.$slots.button || this.$scopedSlots['button']
			},
			hasOptions() {
				return !!this.$slots.options
			},
			iconSizeComputed() {
				return {
					fontSize: `${this.iconSize}px`,
					color: `${this.designBtn == 'primary-alt' && this.status ? '#9CA4B2' : ''}`
				}
			}
		},

		methods: {
			toggle() {
				this.status = !this.status
				this.$emit('input')
			},
			close() {
				this.status = false
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
